import {Location} from '@flowmaps-com/flowmaps-typescriptmodels';

export function meterOutputSettingsFingerprint(location?: Location): string {
    return JSON.stringify((location?.connections || [])
        .map(connection => ({
            connectionId: connection.connectionId,
            connectionType: connection.info?.connectionType,
            connectionLabel: connection.info?.label,
            meters: (connection.meters || [])
                .map(meter => ({
                    meterId: meter.meterId,
                    active: meter.active,
                    parentId: meter.parentId,
                    infoType: meter.info?.type,
                    details: meter.details
                }))
                .sort((left, right) => (left.meterId || '').localeCompare(right.meterId || ''))
        }))
        .sort((left, right) => (left.connectionId || '').localeCompare(right.connectionId || '')));
}
